import { ComponentProps, FC } from "react";
import ButtonPromo from "../../../../presentational/Controls/Button/Button";
import "./Button.scss";

const Button: FC<ComponentProps<typeof ButtonPromo>> = ({ classList, ...otherProps }) => (
  <ButtonPromo classList={`discussion-landing-button ${classList}`} {...otherProps} />
);

export default Button;
